import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { Button } from '../ui/Button';
import { MAIL } from '../../lib/config';
interface ConfirmationScreenProps {
  firstName: string;
  positionTitle: string;
  email: string;
  emailSent: boolean;
}
export function ConfirmationScreen({
  firstName,
  positionTitle,
  email,
  emailSent
}: ConfirmationScreenProps) {
  const headingRef = React.useRef<HTMLHeadingElement>(null);

  // Move focus to the confirmation, so a screen reader user hears the outcome.
  React.useEffect(() => {
    headingRef.current?.focus();
  }, []);
  return <div className="rounded-md border border-line bg-panel p-7 sm:p-10" role="status" data-id="element-644" data-mp="aw848a9xl5cn">
      <CheckCircle2Icon className="h-8 w-8 text-[#6FD39A]" aria-hidden="true" data-id="element-645" data-mp="auetojw760zd" />
      <h2 ref={headingRef} tabIndex={-1} className="mt-5 font-display text-[26px] leading-snug text-ink focus:outline-none sm:text-[32px]" data-id="element-646" data-mp="fo9c7k02g9wv">
        Thank you, {firstName}.
      </h2>
      <p className="mt-4 max-w-prose text-[17px] leading-relaxed text-body" data-id="element-647" data-mp="3j9orhft20k1c">
        We have received your application for {positionTitle}. We will be in touch within two weeks.
      </p>
      <p className="mt-4 max-w-prose text-[15px] text-muted" data-id="element-648" data-mp="2muf2xsh1972l">
        {emailSent ? `A confirmation is on its way to ${email} from ${MAIL.careers}. If it has not arrived within the hour, please check your spam folder.` : `On this preview, email is not connected, so no confirmation has been sent to ${email}. Once the site is live, confirmations come from ${MAIL.careers}.`}
      </p>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-649" data-mp="236frefen9vw4">
        <Button to="/careers" variant="secondary" data-id="element-650" data-mp="1z3riy8tueqzo">
          Back to open positions
        </Button>
        <Button to="/about" variant="ghost" data-id="element-651" data-mp="1u4yd92kss4a2">
          Read more about us
        </Button>
      </div>
    </div>;
}